import React from 'react'

const AnalyticsIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <g stroke={color} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 6v18h21.767" />
        <path d="m4 21.656 8.372-8.372 5.023 4.102 8.372-9.126" />
      </g>
    </svg>
  )
}

export default AnalyticsIcon
